import MvInputParams from "../models/MvInputParams";

export const defaultInputParams: MvInputParams = {
    postalCode: "",
    houseNumber: "",
    streetName: "",
    housePriceType: [],
    houseValue: [300, 500],
    buyRatio: [],
    radius: 400,
};

export const housePriceTypes = [
    { value: "huur", labelId: "general.labels.filterRentalOption" },
    { value: "koop", labelId: "general.labels.filterSaleOption" },
];

export const buyRatioValues = [
    { value: 1, labelId: "filters.scaleText.low" },
    { value: 2, labelId: "filters.scaleText.medium" },
    { value: 3, labelId: "filters.scaleText.high" },
    { value: 4, labelId: "filters.scaleText.veryHigh" },
];

// prettier-ignore
export const houseTypeList  = [
    { value: "Appartement", labelId: "filters.buildingType.appartment" },
    { value: "Vrijstaande woning", labelId: "filters.buildingType.detachedHouse"},
    { value: "Tussenwoning",labelId: "filters.buildingType.midTerraceHouse" },
    { value: "Hoekwoning", labelId: "filters.buildingType.cornerHouse" },
    { value: "2-onder-1-kapwoning", labelId: "filters.buildingType.doubleHouse",  },
];

export const houseTypeListDE = [
    { value: "1", labelId: "filters.buildingType.detachedHouse" },
    { value: "2", labelId: "filters.buildingType.terraceHouse" },
    { value: "3", labelId: "filters.buildingType.smallBlockFlat" },
    { value: "4", labelId: "filters.buildingType.largeBlockFlat" },
    { value: "5", labelId: "filters.buildingType.highRiseBuilding" },
];

export const buildingUsage = [
    { value: "1", labelId: "filters.buildingUsage.residential" },
    { value: "2", labelId: "filters.buildingUsage.mixedUse" },
    { value: "3", labelId: "filters.buildingUsage.commercial" },
    { value: "0", labelId: "filters.buildingUsage.unknown" },
];

// prettier-ignore
export const houseHoldTypes = [
    { value: "singles", labelId: "filters.household.singles"},
    { value: "families", labelId: "filters.household.families"},
    { value: "familiesWithSmallChildren", labelId: "filters.household.familiesWithSmallChildren"},
];

export const buildYears = [
    { value: "1", label: "<1919" },
    { value: "2", label: "1919-1948" },
    { value: "3", label: "1949-1959" },
    { value: "4", label: "1960-1969" },
    { value: "5", label: "1970-1979" },
    { value: "6", label: "1980-1989" },
    { value: "7", label: "1990-1999" },
    { value: "8", label: "2000-2009" },
    { value: "9", label: ">=2010" },
];

export const buildingSizes = [
    { value: "1", labelId: "filters.buildingSize.fam-1-2" },
    { value: "2", labelId: "filters.buildingSize.fam-3-5" },
    { value: "3", labelId: "filters.buildingSize.fam-6-9" },
    { value: "4", labelId: "filters.buildingSize.fam-10-19" },
    { value: "5", labelId: "filters.buildingSize.fam-20-plus" },
];

export const livingAreas = [
    { value: "1", labelId: "filters.scaleText.extremeLow" },
    { value: "2", labelId: "filters.scaleText.veryLow" },
    { value: "3", labelId: "filters.scaleText.low" },
    { value: "4", labelId: "filters.scaleText.middleHigh" },
    { value: "5", labelId: "filters.scaleText.high" },
    { value: "6", labelId: "filters.scaleText.veryHigh" },
    { value: "7", labelId: "filters.scaleText.extremeHigh" },
];

export const residenceLengths = [
    { value: "1", labelId: "filters.residenceLength.lessThanOneYear" },
    { value: "2", labelId: "filters.residenceLength.betweenOneAndTwoYears" },
    { value: "3", labelId: "filters.residenceLength.betweenTwoAndThreeYears" },
    { value: "4", labelId: "filters.residenceLength.betweenThreeAndFourYears" },
    { value: "5", labelId: "filters.residenceLength.betweenFourAndFiveYears" },
    { value: "6", labelId: "filters.residenceLength.betweenFiveAndSixYears" },
    { value: "7", labelId: "filters.residenceLength.betweenSixAndEightYears" },
    { value: "8", labelId: "filters.residenceLength.betweenEightAndTenYears" },
    { value: "9", labelId: "filters.residenceLength.moreThanTenYears" },
];

// prettier-ignore
export const purchasingPowerClasses = [
    { value: "1", labelId: "filters.purchasingPowerClass.farBelowAverage" },
    { value: "2", labelId: "filters.purchasingPowerClass.belowAverage" },
    { value: "3", labelId: "filters.purchasingPowerClass.lowerAverage" },
    { value: "4", labelId: "filters.purchasingPowerClass.average" },
    { value: "5", labelId: "filters.purchasingPowerClass.upperAverage" },
    { value: "6", labelId: "filters.purchasingPowerClass.aboveAverage" },
    { value: "7", labelId: "filters.purchasingPowerClass.farAboveAverage" },
];
